export const iconFontAwesomeFoodBeverageGlassWater = (
	<i className="fa-solid fa-glass-water"></i>
);
